export default __webpack_public_path__ + "media/compass-background.8a3edbd8c5204153c6ecbe9739b5695f.jpg";